import React from 'react'

export const NotFound: React.FC = () => {
  return <h1>404 - Page Not Found</h1>
} 